import axios from "../httpHandler";

export const getDistributes = async (filters) => {
  try {
    const result = await axios.get(`input/dist${filters}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getDistributeStatistics = async (filters) => {
  try {
    const result = await axios.get(`input/dist/statistics${filters}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const createDistribute = async (data) => {
  return axios.post(`input/dist`, {
    ...data,
    'cost': parseInt((data?.cost ?? '0').replaceAll(',', '')),
    'amount': parseInt((data?.amount ?? '0').replaceAll(',', '')),
  });
};
export const deleteDistribute = async ({ id, warehouseSelected }) => {
  const queryParams = warehouseSelected ? '?update_warehouse' : '';
  return axios.delete(`input/dist/${id}${queryParams}`);
};

export const updateDistribute = (data) => {
  return axios.put(`input/dist/${data?.id}`, {
    ...data,
    'cost': parseInt((data?.cost ?? '0').replaceAll(',', '')),
    "amount": parseInt((data?.amount ?? '0').replaceAll(',', '')),
  });
};
